import React from 'react';
import classNames from 'classnames';

export default function Layout(props) {
  return (
    <section className={classNames('hero is-fullheight is-relative is-link', props.className)}>
      <div className="hero-body">{props.children}</div>
    </section>
  );
}
